// React & Vendor Libs
const { useCallback, useEffect, useState, useMemo } = wp.element;

// NekoUI
import { NekoTable, NekoPaging, NekoCheckbox } from '@neko-ui';

import useDatabaseCleanerContext from '../context';

import { LoadEntryModal } from './styled/NekoModal.styled';

const TableEntryModal = () => {

  const { modals, tableEntries, filteredTableColumns, tableColumnsFilter, tableCount,
    tableLimit, tablePage } = useDatabaseCleanerContext();
  const { toggleModal, updateTableColumnsFilter, setTablePage, setTable } = useDatabaseCleanerContext();
  const [ autoFiltered, setAutoFiltered ] = useState();

  const closeTableModal = useCallback(() => {
    toggleModal({modal: 'table', enable: false});
    setTimeout(() => setTable({ table: [] }), 500);
  }, []);

  // useEffect(() => {
  //   const usefulColumns = [ 'ID', 'post_date', 'post_title', 'post_content', 'post_status' ];
  //   console.log(filteredTableColumns);
  //   if (!autoFiltered && tableColumnsFilter.length > 8) {
  //     setAutoFiltered(true);
  //     const hasChange = false;
  //     const newFilters = tableColumnsFilter.map(v => {
  //       if (usefulColumns.includes(v.accessor)) {
  //         return { ...v, checked: true };
  //       }
  //       return { ...v, checked: false };
  //     });

  //     updateTableColumnsFilter(newFilters);
  //     console.log(newFilters);
  //   }
  // }, [filteredTableColumns]);

  const content = useMemo(() => {
    return (
      <>
        {/* <p style={{ marginBottom: 15 }}>You will find those results with all their fields in the console.</p> */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
          {tableColumnsFilter.map((v) => <div style={{ marginRight: '8px' }}><NekoCheckbox id={v.accessor} label={v.label} checked={v.checked} onChange={(checked) => {
            const i = tableColumnsFilter.findIndex(t => t.accessor === v.accessor);
            const newTableColumnsFilter = [...tableColumnsFilter];
            newTableColumnsFilter[i] = { ...v, checked };
            updateTableColumnsFilter(newTableColumnsFilter);
          }} /></div>)}
        </div>
        <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          <div style={{ marginRight: 10 }}>
          {tableEntries.length > 0 ? <NekoTable columns={filteredTableColumns} selectedItems={[]}
            data={tableEntries.map(v => {
              const list = Object.keys(v).map(o => {
                let content = v[o];
                // if content is longer than 100 chars, show only first 100 chars
                if (typeof content === 'string' && content.length > 100) {
                  content = <>{content.substring(0, 100) + '...'} <br /><small><a href="#" onClick={() => { console.log("Content", v[o]); }}>
                    Write to Browser Console
                  </a></small></>
                }
                return {
                  [o]: <p>{content}</p>
                }
              })
              return list.reduce((obj, item) => Object.assign(obj, item), {});
            })} />: <p>No data.</p>}
          </div>
        </div>
      </>
    );
  }, [tableColumnsFilter, tableEntries]);

  return (
    <LoadEntryModal
        isOpen={!!modals.table.enable}
        onRequestClose={closeTableModal}
        title={modals.table.title}
        contentWidth='100%'
        content={content}
        onOkClick={closeTableModal}
        ok='Close'
        okOnEnter={true}
        customButtons={
          <div style={{ marginRight: 'auto' }}>
            <NekoPaging currentPage={tablePage} limit={tableLimit} total={tableCount} onClick={(page) => setTablePage(page)} />
          </div>
        }
        customButtonsPosition="left"
      />
  );
};

export default TableEntryModal;